import { WEBIRM_HOST_LIST } from '@/const/host';
import eventBus from '@rebuild/utils/event-bus';
import { screenShot } from '@/rebuild/hooks/screenShot';

export const useIframeMessage = () => {
	const handlePreviewMessage = e => {
		// 仅通信webirm的域名
		const includeWebIrm = WEBIRM_HOST_LIST.includes(e.origin);
		if (!includeWebIrm) return;

		if (e?.data?.screenshot) screenShot({ token: e.data.token });

		const msgData = e.data || {};
		// 派发事件
		eventBus.emit('iframe-message', msgData);
	};

	const addIframeMessageListener = () => {
		window.addEventListener('message', handlePreviewMessage);
	};

	const removeIframeMessageListener = () => {
		window.removeEventListener('message', handlePreviewMessage);
		// 事件清理
		eventBus.clear('iframe-message');
	};

	return {
		addIframeMessageListener,
		removeIframeMessageListener
	};
};
